import { PageBanner } from '@/ui/PageBanner';

/**
 * Aviso FIXO de pendência sobre a semente do sorteio (D-05, RN-CP-05).
 *
 * A semente é gerada pelo próprio banco no ato, com o compromisso registrado
 * antes da execução. O vínculo com uma fonte pública externa ficou pendente por
 * decisão do dono, e o aviso existe para a pendência não ser esquecida. Não tem
 * botão de fechar de propósito: aviso que some deixa de lembrar.
 */
export function AvisoSementeDoSorteio() {
  return (
    <PageBanner
      tone="warning"
      title="Pendência: fonte pública da semente do sorteio"
      description="O sorteio de cada ciclo usa uma semente gerada pelo próprio sistema no momento da execução, com o compromisso registrado antes dela. Falta decidir o vínculo com uma fonte pública externa, como a extração da Loteria Federal. Até essa decisão, a pendência continua registrada aqui."
    />
  );
}
